"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanActionStatuses = exports.LoanActions = exports.LoanTypes = exports.CalculatedLoanStatuses = exports.LoanStatuses = void 0;
// ***********************************************
//                     LOAN
// ***********************************************
exports.LoanStatuses = [
    'pending',
    'canceled',
    'initiated',
    'funded',
    // *** Edit Post Results ***
    'pendingEdit',
    'overriddenFromEdit',
    'canceledEdit',
];
exports.CalculatedLoanStatuses = ['overdue', ...exports.LoanStatuses];
exports.LoanTypes = ['origination', 'extension', 'rollover'];
exports.LoanActions = ['edit'];
exports.LoanActionStatuses = [
    'submitted',
    'approved',
    'executed',
    'canceled',
    'rejected',
];
//# sourceMappingURL=Loans.js.map